<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">

    <a-form-model-item label="父系列" prop="channel">
      <dict-select v-model="form.data.channel" dict-code="WEBSITE_SERIES_CHANNEL"/>
    </a-form-model-item>
    <a-form-model-item label="名称" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="类型" prop="seriesType">
      <dict-select v-model="form.data.seriesType" dict-code="WEBSITE_SERIES_TYPE"/>
    </a-form-model-item>
    <a-form-model-item label="描述" prop="description">
      <a-textarea v-model="form.data.description"/>
    </a-form-model-item>
    <a-form-model-item label="进一步描述">
      <a-textarea v-model="form.data.detailDescription"/>
    </a-form-model-item>
    <a-form-model-item label="进一步描述背景图片(1920*1080)">
      <div class="a-input">
        <cropper-uploader
          v-model="form.data.detailImage"
          :imageUrl="form.data.detailImage"
          :options="coverOptions2"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="系列缩略图(导航栏展示)" prop='thumbnail'>
      <div class="a-input">
        <cropper-uploader
          v-model="form.data.thumbnail"
          :imageUrl="form.data.thumbnail"
          :options="coverOptions3"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="图片封面-PC端(1920*1080)" prop='coverPath'>
      <div class="a-input">
        <cropper-uploader
          v-model="form.data.coverPath"
          :imageUrl="form.data.coverPath"
          :options="coverOptions1"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="图片封面-移动端(375*724)" prop='coverPathMobile'>
      <div class="a-input">
        <cropper-uploader
          v-model="form.data.coverPathMobile"
          :imageUrl="form.data.coverPathMobile"
          :options="coverOptions4"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!goodsSeriesId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="goodsSeriesId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { _addGoodsSeries, _queryGoodsSeries, _updateGoodsSeries, } from '@/api/websiteGoodsSeriesApi';
import DictSelect from '../../../components/DictSelect.vue';
import CropperUploader from '@/components/CropperUploader.vue';

async function getGoodsSeries() {
  const result = await _queryGoodsSeries(this.goodsSeriesId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.coverPath = result.coverPath;
    this.form.data.coverPathMobile = result.coverPathMobile;
    this.form.data.thumbnail = result.thumbnail;
    this.form.data.nameEn = result.nameEn;
    this.form.data.description = result.description;
    this.form.data.isVip = result.isVip;
    this.form.data.descriptionEn = result.descriptionEn;
    this.form.data.channel = result.channel;
    this.form.data.seriesType = result.seriesType;
    this.form.data.detailDescription = result.detailDescription;
    this.form.data.detailImage = result.detailImage;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsSeries({
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        coverPathMobile: this.form.data.coverPathMobile,
        nameEn: this.form.data.nameEn,
        description: this.form.data.description,
        isVip: this.form.data.isVip,
        descriptionEn: this.form.data.descriptionEn,
        channel: this.form.data.channel,
        seriesType: this.form.data.seriesType,
        detailDescription: this.form.data.detailDescription,
        detailImage: this.form.data.detailImage,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsSeries(this.goodsSeriesId, {
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        coverPathMobile: this.form.data.coverPathMobile,
        goldContent: this.form.data.goldContent,
        thumbnail: this.form.data.thumbnail,
        nameEn: this.form.data.nameEn,
        description: this.form.data.description,
        isVip: this.form.data.isVip,
        descriptionEn: this.form.data.descriptionEn,
        channel: this.form.data.channel,
        seriesType: this.form.data.seriesType,
        detailDescription: this.form.data.detailDescription,
        detailImage: this.form.data.detailImage,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'WebsiteGoodsSeriesEdit',
  components: {
    CropperUploader,
    // SimpleUploader,
    DictSelect,
  },
  props: {
    goodsSeriesId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    goodsSeriesId() {
      if (this.goodsSeriesId) {
        this.getGoodsSeries();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getGoodsSeries,
  },
  data() {
    return {
      coverOptions1: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1920, // 默认生成截图框宽度
        autoCropHeight: 1080, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'S3',
        title: '修改图片',
      },
      coverOptions2: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1920, // 默认生成截图框宽度
        autoCropHeight: 1080, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'S3',
        title: '修改图片',
      },
      coverOptions3: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 390, // 默认生成截图框宽度
        autoCropHeight: 220, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'S3',
        title: '修改图片',
      },
      coverOptions4: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 375, // 默认生成截图框宽度
        autoCropHeight: 724, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'S3',
        title: '修改图片',
      },
      form: {
        data: {
          name: '',
          coverPath: '',
          coverPathMobile: '',
          thumbnail: '',
          nameEn: '',
          description: '',
          descriptionEn: '',
          channel: '',
          seriesType: '',
          detailDescription: '',
          detailImage: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          seriesType: [{ required: true, trigger: 'blur' }],
          // channel: [{ required: true, trigger: 'blur' }],
          description: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.goodsSeriesId) {
      this.getGoodsSeries();
    }
  },
};
</script>
